<template>
  <div
    @click="triangle == 'hide' ? (triangle = 'show') : (triangle = 'hide')"
    class="category-container"
  >
    <div
      v-bind:class="{ toggletriangle: triangle == 'show' }"
      class="triangles"
    ></div>
    <a-collapse v-scroll="handleScroll" ref="mainPanel" :activeKey="open">
      <a-collapse-panel key="1" header="Endre kategori" :show-arrow="false">
        <section class="category-content">
          <template v-for="c in categories">
            <div
              class="prod-card-content"
              :key="c.categoryId"
              v-on:click="handleClickEvent(c, $event)"
            >
              <div class="category-name">{{ c.categoryName }}</div>
              <img
                class="category-image"
                :src="categoryImage(c.categoryName)"
              />
            </div>
          </template>
        </section>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {},

  name: "MenuCategoryView",
  computed: {
    ...mapState({
      categories: state => state.menus.currentMenu.menuCategories,
      products: state => state.menus.currentMenu.menuItems,
      selectedItems: state => state.cart.selectedItems
    })
  },
  data() {
    return {
      triangle: "hide",
      menu: require("@/assets/images/calli-great.png"),
      //
      //categories
      //
      uramaki: require("@/assets/images/categories/uramaki.png"),
      futomaki: require("@/assets/images/categories/futomaki.png"),
      kaburimaki: require("@/assets/images/categories/kaburimaki.png"),
      fujistyle: require("@/assets/images/categories/fujistyle.png"),
      sashimi: require("@/assets/images/categories/sashimi.png"),
      godtblandet: require("@/assets/images/categories/godtogblandet.png"),
      nigiri: require("@/assets/images/categories/nigiri.png"),
      pokebowl: require("@/assets/images/categories/pokebowl.png"),
      vegetar: require("@/assets/images/categories/vegetar.png"),
      extra: require("@/assets/images/categories/extra.jpg"),
      accessories: require("@/assets/images/categories/tilbehor.png"),
      nigiripack: require("@/assets/images/categories/nigiripack.png"),
      fritenstick: require("@/assets/images/categories/varull.png"),
      boba: require("@/assets/images/categories/boba.png"),
      friedroll: require("@/assets/images/categories/friedroll.png"),
      default: require("@/assets/images/categories/default.png"),
      favourites: require("@/assets/images/categories/fav.png"),
      //
      //
      //
      ginger: require("@/assets/images/ginger-guide.png"),
      gokame: require("@/assets/images/gress-guide.png"),
      ponzu: require("@/assets/images/ponzu-guide.png"),
      kimchi: require("@/assets/images/kimchi-guide.png"),
      east: require("@/assets/images/calligraphy-east.png"),
      fresh: require("@/assets/images/calligrqaphy-fresh.png"),
      tofu: require("@/assets/images/tofumaki.png"),
      //
      //
      //
      open: []
    };
  },
  methods: {
    handleScroll: (event, el) => {
      if (
        window.matchMedia("(max-width:480px)").matches &&
        window.scrollY >= 209
      ) {
        el.classList.add("fixed");
      } else {
        el.classList.remove("fixed");
      }
    },
    handleClickEvent(c, event) {
      //let targetId = event.currentTarget.id;
      this.$emit("categoryChosen", c.categoryName);
      this.open = [];
      console.log(c);
    },
    categoryImage(name) {
      //console.log(name)
      switch (name.toLowerCase()) {
        case "godt og blandet":
          return this.godtblandet;
        case "uramaki":
          return this.uramaki;
        case "kaburimaki":
          return this.kaburimaki;
        case "sashimi":
          return this.sashimi;
        case "fuji-style maki":
          return this.fujistyle;
        case "futomaki":
          return this.futomaki;
        case "valfri biter - nigiri og gukan":
          return this.nigiri;
        case "pokebowls":
          return this.pokebowl;
        case "vegetar - retter":
          return this.vegetar;
        case "ekstra":
          return this.extra;
        case "tilbehør":
          return this.accessories;
        case "pure nigiri - 12 biter":
          return this.nigiripack;
        case "frites'n stick":
          return this.fritenstick;
        case "bubble tea":
          return this.boba;
        case "fried rolls":
          return this.friedroll;
        default:
          return this.default;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$desktop: 1980px;
$laptop: 1440px;
$tablet: 769px;
$mobile: 480px;

.triangles {
  &::before {
    content: "";
    width: 0;
    z-index: -1;
    position: absolute;
    left: 44%;
    bottom: -21%;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;

    border-top: 20px solid #bfbcbc;
  }
  &::after {
    content: "";
    position: absolute;
    z-index: 0;
    left: 44%;
    bottom: -20%;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;

    border-top: 20px solid #fafafa;
  }
}
.toggletriangle {
  display: none;
}
.category-image {
  border-radius: 14px;
}

.category-container {
  @media (min-width: $tablet) {
    display: none;
  }
}
.category-content {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
  overflow-y: scroll;
  height: 420px;
}
.category-name {
  width: 100%;
  display: flex;
  align-items: flex-end;
  font-family: bebas;
  font-weight: 600;
  font-size: 15px;
  padding: 0.8em;
  letter-spacing: 0.8px;
}
.prod-card-content {
  background-color: #f5f5f5;
  box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  display: flex;
  height: 115px;
  width: 158px;
  transition: 0.5s;

  & img {
    width: 100%;
    object-fit: cover;
    overflow-x: hidden;
    clip-path: polygon(
      84% 0,
      100% 0,
      100% 35%,
      100% 70%,
      100% 100%,
      24% 100%,
      21% 70%,
      15% 44%,
      8% 21%,
      0 0
    );
  }
}

.prod-card-content:hover {
  transform: scale(1.02);
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
}
.header-background-image {
  background-image: url("~@/assets/images/sushi-menu-header.png");
  background-size: cover;

  margin-top: 10px;
  height: 490px;
  width: 100%;
  object-fit: cover;

  display: grid;
  place-items: center;
  @media (max-width: $mobile) {
    height: 200px;
    position: static;
    bottom: 0;
  }
}
.about-title-logo {
  position: relative;
  bottom: 20px;
  width: 80px;
  @media (max-width: $mobile) {
    height: 40px;
    width: auto;
  }
}
.header-title-container {
  background-color: white;

  height: 200px;
  width: 18%;
  border-radius: 50px;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 100px;
    width: 50%;
    border-radius: 30px;
  }
}
.about-header-title {
  text-align: center;
  text-transform: uppercase;
  font-family: Bebas;
  font-weight: 400;
  margin: 0 0 0.67em 0;
  font-size: 2vw;
  margin: 0;
  @media (max-width: $mobile) {
    font-size: 2em;
    position: relative;
    bottom: 10px;
    letter-spacing: 1px;
  }
}
.header-background-image h4 {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: 400 !important;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #878787;
  position: relative;
  top: 25px;
  @media (max-width: $mobile) {
    font-size: 1em;
    top: 10px;
  }
}
.fixed {
  position: fixed !important;
  top: 64px;
  left: 0;
  width: 100%;
  background-color: rgba(245, 245, 245, 1) !important;
  box-shadow: 0 2px 2px #efefef;
  z-index: 99;
  transition: 1s;
  overflow-x: scroll;
  border-top: solid 0.5px #eaeaea;
  display: initial;
}
</style>
